export enum RequirementRouteNav {
  Info = "info",
  Assessment = "assessment",
  AdditionalInfo = "additional-info",
  TotalOverview = "total-overview",
}
